import { noCase } from 'change-case';
import { formatEntityName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const createEntityStmtInstruction = `
#### Entity Creation
- Syntax: \`create entity <entity_name>;\`
- Example: \`create entity Post;\``;
export const stmtCreateEntity = ({ entityName }) => {
    return `create entity ${entityName};`;
};
export const stmtForHumanCreateEntity = ({ entityName }) => {
    return `A new database table named __${noCase(entityName)}__ will be created.`;
};
export const createEntityHandler = createSchemaStatementHandler({
    type: 'create entity',
    parse: line => {
        const match = /^(add|create) entity (?<entityName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'create entity',
                entityName: formatEntityName(match.groups.entityName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanCreateEntity,
    apply: (stmt, builder) => {
        builder.updateSchema(it => it.addEntity({ name: stmt.entityName }));
    },
});
//# sourceMappingURL=CreateEntityStmt.js.map